import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api/client';

export default function VerifyEmail() {
  const [status, setStatus]   = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');
  const [searchParams]        = useSearchParams();
  const { login }             = useAuth();
  const navigate              = useNavigate();
  const token                 = searchParams.get('token');

  useEffect(() => {
    if (!token) { setStatus('error'); setMessage('No verification token found. Please check your email link.'); return; }

    api.get(`/auth/verify-email?token=${token}`)
      .then(({ data }) => {
        /* Store JWT and user — they're now logged in */
        localStorage.setItem('ef_token', data.token);
        localStorage.setItem('ef_user',  JSON.stringify(data.user));
        setStatus('success');
        setMessage(data.message || 'Email verified successfully!');
        /* Redirect to dashboard after 2.5 seconds */
        setTimeout(() => navigate('/dashboard'), 2500);
      })
      .catch(err => {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Verification failed. The link may be expired or already used.');
      });
  }, [token, navigate]);

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>Qu<span style={{ color: '#4f6ef7' }}>vera</span></div>

        {status === 'verifying' && (
          <>
            <div style={s.spinner} />
            <h2 style={s.h2}>Verifying your email…</h2>
            <p style={s.p}>Please wait a moment.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={s.iconCircle('#dcfce7')}>
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M6 16l7 7 13-13" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2 style={s.h2}>Email Verified! 🎉</h2>
            <p style={s.p}>{message}</p>
            <p style={{ ...s.p, color: '#9099b4', fontSize: 13 }}>Redirecting you to your dashboard…</p>
            <Link to="/dashboard" style={s.btn}>Go to Dashboard →</Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={s.iconCircle('#fee2e2')}>
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M10 10l12 12M22 10L10 22" stroke="#dc2626" strokeWidth="2.5" strokeLinecap="round"/>
              </svg>
            </div>
            <h2 style={s.h2}>Verification Failed</h2>
            <p style={s.p}>{message}</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 8 }}>
              <Link to="/signup" style={s.btn}>Sign Up Again</Link>
              <Link to="/login"  style={s.btnOutline}>Back to Login</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const s = {
  page:       { minHeight: '100vh', background: '#f8f9fc', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Sans',sans-serif", padding: 24 },
  card:       { background: '#fff', borderRadius: 20, padding: '48px 40px', maxWidth: 420, width: '100%', textAlign: 'center', boxShadow: '0 4px 24px rgba(15,18,51,.08)', border: '1px solid #e2e6f0' },
  logo:       { fontFamily: "'Sora',sans-serif", fontSize: 24, fontWeight: 700, color: '#1a1f5e', marginBottom: 32 },
  spinner:    { width: 48, height: 48, border: '4px solid #e2e6f0', borderTopColor: '#4f6ef7', borderRadius: '50%', animation: 'spin .7s linear infinite', margin: '0 auto 24px' },
  iconCircle: (bg) => ({ width: 72, height: 72, borderRadius: '50%', background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }),
  h2:         { fontFamily: "'Sora',sans-serif", fontSize: 22, fontWeight: 700, color: '#1a1f5e', marginBottom: 12 },
  p:          { fontSize: 15, color: '#636b89', lineHeight: 1.65, marginBottom: 8 },
  btn:        { display: 'block', padding: '12px 24px', background: '#4f6ef7', color: '#fff', borderRadius: 10, fontSize: 14, fontWeight: 700, textDecoration: 'none', marginTop: 20 },
  btnOutline: { display: 'block', padding: '12px 24px', background: '#fff', color: '#1a1f5e', borderRadius: 10, fontSize: 14, fontWeight: 600, textDecoration: 'none', border: '1.5px solid #e2e6f0' },
};
